module.exports = __webpack_public_path__ + "img/boat10.4f0c627b.jpg";